import React, { useContext } from 'react'
import eventBus from './event-bus'

const eventBusContext = React.createContext(eventBus())

export const useEventBus = () => useContext(eventBusContext)
